<template>
  <div class="inicio">
    <mq-layout mq="sm">
      <Informes/>
    </mq-layout>
    <mq-layout mq="md+">
      <SliderMain/>
      <ArchiveInformes/>
      <SupportMain/>
    </mq-layout>
  </div>
</template>

<script>
import SliderMain from '@/templates/_SliderMain'
import ArchiveInformes from '@/templates/_ArchiveInformes'
import SupportMain from '@/templates/_SupportMain'
import Informes from '@/views/Informes'

export default {
  name: 'Inicio',
  components: {
    SliderMain,
    ArchiveInformes,
    SupportMain,
    Informes
  }
}
</script>

<style lang="sass">

</style>
